import React from "react";

import RootRoute from "Routes/RootRoute";

import "semantic-ui-css/semantic.min.css";
import "Styles/main.scss";

const App = () => <RootRoute />;

export default App;
